var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailCircleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.506,
    height: 49.506,
    viewBox: "0 0 49.506 49.506",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_135",
    "data-name": "Component 135",
    transform: "translate(0.753 0.753)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_105",
    "data-name": "Ellipse 105",
    cx: 24,
    cy: 24,
    r: 24,
    fill: "none",
    stroke: "#e62a32",
    strokeMiterlimit: 10,
    strokeWidth: 1.506
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2288",
    "data-name": "Path 2288",
    d: "M467.875,264.251",
    transform: "translate(-443.875 -243.609)",
    fill: "none",
    stroke: "#e62a32",
    strokeMiterlimit: 10,
    strokeWidth: 1.506
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2289",
    "data-name": "Path 2289",
    d: "M456.752,277.84l9.487-7.443a2.634,2.634,0,0,1,3.25,0l9.51,7.448",
    transform: "translate(-443.875 -243.609)",
    fill: "none",
    stroke: "#e62a32",
    strokeMiterlimit: 10,
    strokeWidth: 1.506
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3915",
    "data-name": "Group 3915",
    transform: "translate(-443.875 -243.609)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_182",
    "data-name": "Line 182",
    x1: 9.158,
    y1: 6.973,
    transform: "translate(455.479 264.417)",
    fill: "none",
    stroke: "#e62a32",
    strokeMiterlimit: 10,
    strokeWidth: 1.506
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_183",
    "data-name": "Line 183",
    x1: 9.078,
    y2: 7.169,
    transform: "translate(471.194 264.41)",
    fill: "none",
    stroke: "#e62a32",
    strokeLinejoin: "round",
    strokeWidth: 1.506
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2290",
    "data-name": "Path 2290",
    d: "M458.413,266.47V256.089a.789.789,0,0,1,.789-.789h17.347a.789.789,0,0,1,.789.789V266.6",
    transform: "translate(-443.875 -243.609)",
    fill: "none",
    stroke: "#e62a32",
    strokeMiterlimit: 10,
    strokeWidth: 1.506
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2291",
    "data-name": "Path 2291",
    d: "M458.278,262.043l-2.819,2.208-.036.067v11.226a2.634,2.634,0,0,0,2.634,2.634h19.637a2.634,2.634,0,0,0,2.634-2.634V264.251h-.011l-2.979-2.334",
    transform: "translate(-443.875 -243.609)",
    fill: "none",
    stroke: "#e62a32",
    strokeLinejoin: "round",
    strokeWidth: 1.506
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2292",
    "data-name": "Path 2292",
    d: "M464.06,263.613l2.183,2.36,5.877-6.236",
    transform: "translate(-443.875 -243.609)",
    fill: "none",
    stroke: "#e62a32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.506
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailCircleIcon);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };